import styled from '@emotion/styled'
import { graphql, PageProps } from 'gatsby'
import React from 'react'
import CommonH2 from '../../components/atoms/commonH2'
import SEO from '../../components/atoms/seo'
import { ITopicPath } from '../../components/atoms/topicPath'
import CategoryCard from '../../components/molecules/categoryCard'
import Layout from '../../components/organisms/layout'
import BreakPoints from '../../styles/breakPoints'
import { CategoryKind } from '../../types/CategoryKind'
import useRouteParam from '../../hooks/useRouteParam'

const Wrapper = styled.div`
  .category-card:nth-of-type(5) {
    height: 293px;
  }
  ${BreakPoints.medium} {
    .category-card {
      height: auto;
    }
  }
`

type IProps = PageProps<GatsbyTypes.FaqPageQuery>

/**
 * よくあるご質問ページ
 * @constructor
 */
const FaqPage = ({ data, location }: IProps) => {
  // GraphQLで取得したデータを保持
  const items = data.awsGraphQL.listHelpCategories?.items || []

  const paths: ITopicPath[] = [
    { title: 'TOP', link: useRouteParam('/help') },
    { title: 'よくあるご質問' },
  ]
  return (
    <Layout location={location} paths={paths} categoryKind={CategoryKind.FAQ}>
      <SEO title="よくあるご質問" />
      <CommonH2 label="よくあるご質問" />
      <p className="txt-center mt-020 mb-020">
        キンクラをご利用の上で、よくいただくご質問をご紹介します。
      </p>
      <Wrapper>
        {[...items]
          .sort((a, b) => (a?.sortNo || 0) - (b?.sortNo || 0))
          .filter((item) => !item?._deleted)
          .map((item) => {
            const helpCategoryId = item?.helpCategoryId || ''
            const slug = item?.slug || ''
            const title = item?.title || ''
            return (
              <CategoryCard
                key={`category-card-${helpCategoryId}`}
                helpCategoryId={helpCategoryId}
                categoryTitle={title}
                slug={slug}
                limit={10}
                visibleAllLink
              />
            )
          })}
      </Wrapper>
    </Layout>
  )
}

export default FaqPage

export const pageQuery = graphql`
  query FaqPage {
    awsGraphQL {
      listHelpCategories(filter: { categoryKind: { eq: 5 } }) {
        items {
          helpCategoryId
          sortNo
          title
          slug
          categoryKind
          _deleted
        }
      }
    }
    site {
      siteMetadata {
        title
      }
    }
  }
`
